import React from 'react'
import './Experience.css'
import { 
  FaHtml5, 
  FaCss3Alt, 
  FaJs, 
  FaReact, 
  FaNodeJs, 
  FaPhp, 
  FaDatabase,
  FaCode,
  FaServer
} from "react-icons/fa";

function Experience() {
  const frontendSkills = [
    { name: 'HTML5', level: 95, icon: <FaHtml5 />, color: '#e34c26' },
    { name: 'CSS3', level: 90, icon: <FaCss3Alt />, color: '#1572b6' },
    { name: 'JavaScript', level: 88, icon: <FaJs />, color: '#f7df1e' },
    { name: 'React', level: 85, icon: <FaReact />, color: '#61dafb' }
  ];

  const backendSkills = [
    { name: 'Node.js', level: 82, icon: <FaNodeJs />, color: '#339933' },
    { name: 'PHP', level: 75, icon: <FaPhp />, color: '#777bb4' },
    { name: 'MySQL', level: 80, icon: <FaDatabase />, color: '#4479a1' },
    { name: 'MongoDB', level: 78, icon: <FaDatabase />, color: '#4db33d' }
  ];

  const SkillCard = ({ title, icon: TitleIcon, skills, className }) => (
    <div className={`skill-card ${className}`}>
      <div className="skill-card-header">
        <div className="skill-card-icon">
          {TitleIcon}
        </div>
        <h3>{title}</h3>
      </div>
      <div className="skills-grid">
        {skills.map((skill, index) => (
          <div key={index} className="skill-item">
            <div className="skill-info">
              <div className="skill-icon" style={{ color: skill.color }}>
                {skill.icon}
              </div>
              <div className="skill-details">
                <h4>{skill.name}</h4>
                <span className="skill-level">{skill.level}%</span>
              </div>
            </div>
            <div className="skill-progress">
              <div 
                className="skill-progress-bar" 
                style={{ 
                  width: `${skill.level}%`,
                  background: `linear-gradient(90deg, ${skill.color}, ${skill.color}cc)`
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <section id='experience' className="experience-section">
      <div className="experience-container">
        <div className="experience-header">
          <h5 className="section-subtitle">What Skills I Have</h5>
          <h2 className="section-title">My Experience</h2>
          <div className="experience-divider"></div>
        </div>

        <div className="skills-container">
          <SkillCard 
            title="Frontend Development" 
            icon={<FaCode />}
            skills={frontendSkills}
            className="frontend-card"
          />
          
          <SkillCard 
            title="Backend Development" 
            icon={<FaServer />}
            skills={backendSkills}
            className="backend-card"
          />
        </div>
      </div>
    </section>
  )
}

export default Experience